import React from "react";


import { Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import { AUTHENTICATED_ENTRY } from "configs/AppConfig";
import { protectedRoutes, publicRoutes } from "configs/RoutesConfig";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
import AppRoute from "./AppRoute";
import { useAuth } from "context/AuthContext";


// import NewHeader from "components/layout-components/Web/WebHeader";
const Routes = () => {
  const { userDetails } = useAuth();
  const role = userDetails.roleName || "";
  let protectedRoute = [];
  if (role === "Super-Admin") {
    protectedRoute = protectedRoutes[role] || [];
  } else {
    const protectedRoute_all = protectedRoutes[role] || [];

    protectedRoute =
      userDetails?.accessLevel && protectedRoute_all.length > 0
        ? protectedRoute_all.filter((navigation) =>
          userDetails.accessLevel.some(
            (accessLevel) =>
              (accessLevel?.levelName && accessLevel?.permissions?.some((permission) => permission + accessLevel?.levelName === navigation?.key)) ||
              "dashboard" === navigation?.key ||
              "profile" === navigation?.key ||
              "viewattendance" === navigation?.key ||
              // "myholiday" === navigation?.key ||
              // "myattendance" === navigation?.key ||
              "viewleave" === navigation?.key ||
              // "myleave" === navigation?.key ||
              "viewreg-request" === navigation?.key ||
              // "myreg-request" === navigation?.key ||
              "viewreimbursement" === navigation?.key ||
              // "myreimbursement" === navigation?.key ||
              "viewcompoff" === navigation?.key
            // ||
            // "mycompoff" === navigation?.key 
          )
        )
        : [];
  }

  return (
    <RouterRoutes>
      <Route path="/" key={`PublicRoute`} element={<PublicRoute />}>
        {publicRoutes.map((route) => {
          return <Route key={route.path} path={route.path} element={<AppRoute routeKey={route.key} component={route.component} {...route.meta} />} />;
        })}
      </Route>
      <Route path="/" key={`ProtectedRoute`} element={<ProtectedRoute />}>
        <Route path="/" key={`/`} element={<Navigate replace to={AUTHENTICATED_ENTRY} />} />
        {(protectedRoute ?? []).map((route, index) => {
          return <Route key={route.key + index} path={route.path} element={<AppRoute routeKey={route.key} component={route.component} {...route.meta} />} />;
        })}
        <Route path="*" key={`*`} element={<Navigate to="/" replace />} />
      </Route>
    </RouterRoutes>
  );
};

export default Routes;
